import { GET_PEOPLE_COUNT_SUCCESS } from "../types";

export const setPeopleCount = (data) => {
  return {
    type: GET_PEOPLE_COUNT_SUCCESS,
    payload: data,
  };
};
